import getScreenWidth from './getScreenWidth';

const isMobile = (sw = '') => {
  const screenWidth = getScreenWidth();
  const screen = sw === '' ? screenWidth : sw;
  return (screen === 'xs' || screen === 'sm');
};

export default isMobile;
